<template>
    <div class="approval-task">
        <Modal
            v-model="currentApprovalTask"
            @on-cancel="cancleApprovalTask"
            transfer="false"
            width="60"
            footer-hide="true"
        >
            <div class="approval-task-left" v-if="ifBind">
                <div class="flow-diagram" v-if="ifBind">
                    <FlowDiagram
                        v-if="currentApprovalTask"
                        :flowChartInfo="flowChartInfo"
                        :ifJustShowMsg="ifJustShowMsg"
                        :processInstanceId="transInfomation"
                        @processChartNodeMsg="processChartNodeMsg"
                    ></FlowDiagram>
                </div>
                <div class="bottom-infomation">
                    <div v-if="!showNodeMsg">
                        <h3>
                            {{ data.name ? data.name : '' }}
                        </h3>
                        <div class="infomation-item">
                            <p class="key-title">流程标识</p>
                            <p class="value-info">
                                {{ data.key ? data.key : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">创建人</p>
                            <p class="value-info">
                                {{ data.createdBy ? data.createdBy : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">描述信息</p>
                            <p class="value-info">
                                {{ data.description ? data.description : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">流程版本</p>
                            <p class="value-info">
                                {{ data.version ? data.version : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">最近更新</p>
                            <p class="value-info">
                                {{ data.lastUpdated ? data.lastUpdated : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">最近更新人</p>
                            <p class="value-info">
                                {{ data.lastUpdatedBy ? data.lastUpdatedBy : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">是否为最新版本</p>
                            <p class="value-info">
                                {{ data.latestVersion ? data.latestVersion : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">模型类型</p>
                            <p class="value-info">
                                {{ data.modelType ? data.modelType : '空值' }}
                            </p>
                        </div>
                        <div class="infomation-item">
                            <p class="key-title">流程作者</p>
                            <p class="value-info">
                                {{ data.tenant ? data.tenant : '空值' }}
                            </p>
                        </div>
                    </div>
                    <div v-if="showNodeMsg">
                        <h3>
                            {{ nodeMsg.taskDefinitionKey ? nodeMsg.taskDefinitionKey : '' }}
                        </h3>
                        <div class="infomation-item">
                            <p class="key-title">开始时间：</p>
                            <p class="value-info">
                                {{ nodeMsg.startTime ? nodeMsg.startTime : '暂无' }}
                            </p>
                        </div>

                        <div class="infomation-item">
                            <p class="key-title">结束时间：</p>
                            <p class="value-info">
                                {{ nodeMsg.endTime ? nodeMsg.endTime : '暂无' }}
                            </p>
                        </div>

                        <div class="infomation-item">
                            <p class="key-title">节点名称：</p>
                            <p class="value-info">
                                {{ nodeMsg.taskDefinitionKey ? nodeMsg.taskDefinitionKey : '暂无' }}
                            </p>
                        </div>

                        <div class="infomation-item">
                            <p class="key-title">审核意见：</p>
                            <p class="value-info">
                                {{ nodeMsg.audit_desc ? nodeMsg.audit_desc : '暂无' }}
                            </p>
                        </div>

                        <div class="infomation-item">
                            <p class="key-title">市场意见：</p>
                            <p class="value-info">
                                {{
                                    nodeMsg.product_audit_desc ? nodeMsg.product_audit_desc : '暂无'
                                }}
                            </p>
                        </div>

                        <div class="infomation-item">
                            <p class="key-title">审核结果：</p>
                            <p class="value-info">
                                {{ nodeMsg.result ? nodeMsg.result : '暂无' }}
                            </p>
                        </div>

                        <div class="infomation-item">
                            <p class="key-title">审核人：</p>
                            <p class="value-info">
                                {{ nodeMsg.userId ? nodeMsg.userId : '暂无' }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="not-bind" v-if="!ifBind">
                <img src="@/assets/images/icon_blank.png" alt="未绑定显示文件" />
                <p class="ys-common-FontColor">未绑定相关流程</p>
            </div>
            <div :class="'approval-task-right'">
                <div class="approval-info">
                    <div class="info-item">
                        <div class="item-title">
                            服务名称
                        </div>
                        <div class="item-msg">
                            {{
                                delateItem
                                    ? delateItem.srv_name
                                        ? delateItem.srv_bk_desc
                                            ? delateItem.srv_name + ' ' + delateItem.srv_bk_desc
                                            : delateItem.variableInstances
                                            ? delateItem.variableInstances.srv_bk_desc
                                                ? delateItem.srv_name +
                                                  ' ' +
                                                  delateItem.variableInstances.srv_bk_desc
                                                : delateItem.srv_name
                                            : delateItem.srv_name
                                        : '暂不存在'
                                    : '暂不存在'
                            }}
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="item-title">
                            审批流程
                        </div>
                        <div class="item-msg">
                            {{
                                ifBind
                                    ? delateItem
                                        ? delateItem.business_key
                                            ? delateItem.business_key
                                            : bindService
                                        : bindService
                                    : bindService
                            }}
                        </div>
                    </div>
                    <div v-if="ifJustShowMsg">
                        <div class="info-item">
                            <div class="item-title">
                                发起人
                            </div>
                            <div class="item-msg">
                                {{ delateItem.initiator }}
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="item-title">
                                审批人
                            </div>
                            <div class="item-msg">
                                {{ delateItem.approver }}
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="item-title">
                                发起时间
                            </div>
                            <div class="item-msg">
                                {{ delateItem.time }}
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="item-title">
                                服务信息
                            </div>
                            <div class="item-msg">
                                {{ delateItem.srv_name }}
                            </div>
                        </div>
                    </div>
                    <div class="info-item switch-item" v-if="!ifJustShowMsg">
                        <div class="item-title">
                            绑定状态
                        </div>
                        <i-switch v-model="ifBind" @on-change="ChangeStatus" />
                    </div>
                </div>
                <div class="service-serch" v-if="!ifJustShowMsg">
                    <Input
                        icon="ios-search"
                        placeholder="输入您要搜索的流程"
                        style="margin:7px;"
                        v-model="search_process"
                        @on-click="searchProcess"
                    />
                    <div class="service-info">
                        <ul v-if="processDeploymentsName">
                            <li
                                v-for="(item, index) in processDeploymentsName"
                                :key="index"
                                @click="clickThisServe($event)"
                            >
                                {{ item }}
                            </li>
                        </ul>
                        <ul v-else>
                            <li>
                                &nbsp;&nbsp;&nbsp; 暂无数据
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btn-tools" v-if="!ifJustShowMsg">
                    <button type="button" class="btn-text" @click="cancleApprovalTask">取消</button>
                    <button type="button" class="btn-primary" @click="bindServe">确定</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import FlowDiagram from './FlowDiagram';
import axios from 'axios';
export default {
    name: 'approvalTask',
    props: {
        currentApprovalTask: {
            type: Boolean,
            default: false,
        },
        delateItem: {
            type: Object,
            default: {},
        },
        ifJustShowMsg: {
            type: Boolean,
            default: false,
        },
    },
    components: { FlowDiagram },

    mixins: {},
    data() {
        return {
            ifBind: false,
            /* 流程 */
            processDeployments: [],
            /* 流程名列表 */
            processDeploymentsName: [],
            processDeploymentsKey: [],
            /* 绑定服务名 */
            bindService: '',
            /* 流程 */
            search_process: '',
            data: [],
            /* 流程图信息 */
            flowChartInfo: {},
            searchProcessId: '',
            filter: '',
            /* 传递到流程图组件的信息 */
            transInfomation: '',
            process_title: '',
            /* 点击流程图节点 */
            showNodeMsg: false,
            nodeMsg: {},
        };
    },
    filters: {},
    watch: {
        delateItem: {
            handler(newVal) {
                this.searchProcessId = newVal.processDefinitionId ? newVal.processDefinitionId : '';
                this.filter = newVal.business_key;
                this.processInfo();
                this.processChartMsg();
                if (this.ifJustShowMsg) {
                    this.transInfomation = newVal.processInstanceId;
                }
                if (this.delateItem.flowable_key) {
                    var result = this.processDeployments.filter(item => {
                        return item.key == this.delateItem.business_key;
                    });
                    this.searchProcessId = result[0].id;
                    this.filter = this.delateItem.business_key;
                    var process_name = result[0].id.split(':')[0];
                    var result = this.processDeploymentsKey.indexOf(process_name);
                    if (result != -1 && !this.ifJustShowMsg) {
                        this.bindProcessBgColor(result);
                    }
                }
            },
            deep: true,
        },
    },

    mounted() {
        this.searchProcess();
        this.processInfo();
        this.processChartMsg();
    },
    beforeUpdate() {
        this.delateItem
            ? this.delateItem.flowable_key
                ? (this.ifBind = true)
                : (this.ifBind = false)
            : false;
    },

    methods: {
        ...mapActions([
            'sa_PageSrvByFunTypeActionProcessApiDeployments' /*获取流程*/,
            'sa_PageSrvByFunTypeAction_updateFlowableFlag' /*服务绑定*/,
            'sa_SpringFlowableActionView_qryProcessChartMsg',
        ]),

        cancleApprovalTask() {
            this.$emit('cancleApproval', false);
            this.showNodeMsg = false;

            if (!this.delateItem.flowable_key) {
                this.clearServeBgColor();
            }
        },
        /* 开关更改 */
        ChangeStatus() {
            this.delateItem.flowable_key = this.ifBind;
            this.clearServeBgColor();
        },
        /* 点击服务 */
        clickThisServe(ev) {
            var temp = ev.target.parentNode.children;
            var length = temp.length;
            if (this.ifBind == true) {
                for (var i = 0; i < length; i++) {
                    temp[i].style.background = 'none';
                }
                ev.target.style.background = '#7389b0';
            } else {
                for (var i = 0; i < length; i++) {
                    temp[i].style.background = 'none';
                }
            }
            var result = this.processDeploymentsName.indexOf(ev.target.innerText);
            this.bindService = this.processDeploymentsKey[result];
            this.processInfo();
            this.processChartMsg();
        },

        clearServeBgColor() {
            var serviceInfo = document.getElementsByClassName('service-info')[0].children[0]
                .children;
            var length = serviceInfo.length;
            for (var i = 0; i < length; i++) {
                serviceInfo[i].style.background = 'none';
            }
        },
        /* 绑定服务 */
        bindServe() {
            var result = this.processDeployments.filter(item => {
                return item.key == this.bindService;
            });

            var flowable_key = result[0] ? result[0].id : '';
            const parmas = {
                business_key: result[0] ? result[0].key : '',
                flowable_key,
                srv_name: this.delateItem.srv_name,
            };
            this.sa_PageSrvByFunTypeAction_updateFlowableFlag(parmas);
            this.$emit('cancleApproval', false);
        },
        /* 查询服务 */
        searchProcess() {
            this.sa_PageSrvByFunTypeActionProcessApiDeployments({
                keyLike: '%' + this.search_process + '%',
            })
                .then(res => {
                    var temp = res.data.data;
                    this.processDeployments = res.data.data;
                    this.processDeploymentsName = [];
                    this.processDeploymentsKey = [];
                    temp.map(item => {
                        if (this.processDeploymentsKey.indexOf(item.key) == -1) {
                            this.processDeploymentsKey.push(item.key);
                        }
                    });
                    temp.map(item => {
                        if (this.processDeploymentsName.indexOf(item.name) == -1) {
                            this.processDeploymentsName.push(item.name);
                        }
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        },
        /* 服务流程图 */
        processInfo() {
            var nowTime = new Date().getTime();
            if (!this.ifJustShowMsg && this.ifBind) {
                var result = this.processDeployments.filter(item => {
                    return item.key == this.bindService;
                });
                this.searchProcessId = result[0] ? result[0].id : '';
            }

            if (this.searchProcessId) {
                axios
                    .get(
                        `${window.GlobalConfig.serviceProxy.ApprovalUrl}app/rest/admin/process-definitions/${this.searchProcessId}/model-json?nocaching=${nowTime}`
                    )
                    .then(res => {
                        if (res.data.elements) {
                            this.flowChartInfo = res.data;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        /* 流程图中的信息 */
        processChartMsg() {
            if (!this.ifJustShowMsg && this.ifBind) {
                this.filter = this.bindService;
            }
            if (this.filter) {
                this.sa_SpringFlowableActionView_qryProcessChartMsg({})
                    .then(res => {
                        if (res) {
                            this.data = res;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },

        bindProcessBgColor(index) {
            var process_box = document.getElementsByClassName('service-info')[0].children[0]
                .children;
            if (process_box[index]) {
                process_box[index].style.background = '#7389b0';
                this.processInfo();
                this.processChartMsg();
            }
        },
        processChartNodeMsg(data, bool) {
            this.showNodeMsg = bool;
            this.nodeMsg = data;
        },
    },
};
</script>

<style lang="less" scoped>
.approval-task {
    /deep/ .ivu-modal {
        height: 100%;
        .ivu-modal-content {
            height: 70%;
            background: #2f3e59;
            position: relative;
            &::after {
                content: '';
                display: block;
                height: 100%;
                width: 35%;
                right: 0;
                top: 0;
                position: absolute;
                background: rgba(85, 107, 144, 1);
            }
            .ivu-modal-header {
                z-index: 10000;
            }
            .ivu-modal-body {
                height: 100%;
                display: flex;
                justify-content: space-between;
                .approval-task-left {
                    height: 100%;
                    width: 65%;
                    padding: 0 20px;
                    .flow-diagram {
                        height: 40%;
                        width: 100%;
                        border: 1px solid #cfd7e5;
                        margin: 10px auto;
                        overflow: auto;
                    }
                    .bottom-infomation {
                        height: 60%;
                        padding: 10px 0;
                        h3 {
                            font: 500 16px/22px 'PingFang SC';
                            color: #d9e3f3;
                            height: 30px;
                        }
                        .infomation-item {
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 5px;

                            .key-title {
                                font: 500 14px/20px 'PingFangSC-Regular';
                                color: #a3b1cc;
                            }
                            .value-info {
                                text-align: left;
                                font: 400 14px/22px 'PingFangSC-Regular';
                                color: #cfd7e5;
                            }
                        }
                    }
                }
                .not-bind {
                    height: 100%;
                    width: 65%;
                    padding: 0 20px;
                    margin: 0 auto;
                    text-align: center;
                    position: relative;
                    p {
                        position: absolute;
                        left: 42%;
                        top: 55%;
                        font-size: 16px;
                        font-family: 'PingFang SC';
                        font-weight: 400;
                        line-height: 22px;
                    }
                }
                .approval-task-right {
                    height: 90%;
                    width: 35%;
                    z-index: 10000;
                    margin-top: 10px;
                    padding: 0 15px;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    .approval-info {
                        width: 100%;
                        padding: 0 10px;
                        margin-bottom: 10px;
                        .info-item {
                            font: 400 14px/20px 'PingFang SC';
                            height: 55px;
                            .item-title {
                                height: 25px;
                                color: #a3b1cc;
                                padding: 5px 0;
                            }

                            .item-msg {
                                padding: 5px 0;
                                height: 25px;
                                font-weight: 500;
                                color: #cfd7e5;
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            .item-msg:hover {
                                width: 150%;
                            }
                        }
                        .switch-item {
                            .item-title {
                                margin-bottom: 5px;
                            }
                        }
                    }
                    .service-serch {
                        height: 65%;
                        background: #cfd7e5;
                        margin: 0 -10px 10px 10px;
                        border-radius: 4px;
                        .ivu-input-wrapper {
                            width: 96% !important;
                            input {
                                color: #333;
                            }
                        }

                        .service-info {
                            width: 97%;
                            height: 90%;
                            ul {
                                overflow: auto;
                                height: 93%;

                                &::-webkit-scrollbar {
                                    width: 4px;
                                }
                                &::-webkit-scrollbar-thumb {
                                    background: #4e6389;
                                    border-radius: 3px;
                                    margin-right: 3px;
                                }
                                li {
                                    padding: 5px 0 0 10px;
                                    height: 30px;
                                    font: 500 14px/22px 'PingFang SC';
                                    color: #333;
                                    &:hover {
                                        background: #7389b0 !important;
                                    }
                                }
                            }
                        }
                    }
                    .btn-tools {
                        position: absolute;
                        right: 0;
                        bottom: -35px;
                        .btn-text {
                            color: #0091ff;
                            height: 40px;
                            width: 80px;
                            background: #252e40;
                            border: 1px solid #0061ff;
                            opacity: 1;
                            border-radius: 4px;
                            margin-right: 10px;
                        }
                        .btn-primary {
                            background: #0061ff;
                            color: #fff;
                            font: 14px/40px 'PingFang SC';
                            border-radius: 4px;
                            height: 40px;
                            width: 80px;
                            border: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
